<template>
  <v-dialog v-model="value" max-width="400" :dark="dark">
    <v-card :color="color" >
      <v-card-title class="text-subtitle-1">
        {{ $dictionary.get('position-need-location-1') }}
      </v-card-title>
      <v-card-text>
        <Button :to="{name: 'address'}" title="position-need-location-2" />
        <Button @click="close" title="close" sub-button />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from '@/components/dialogs/DialogMixin';
import Button from '@/components/Button';

export default {
  name: 'NeedLocation',
  components: { Button },
  mixins: [DialogMixin]
};
</script>
